// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import '../css/common.css';
import '../css/initialConfigStyle.css';
import InitialConfigHeader from '../components/InitialConfig/UserInitialConfigHeader';
import StepIntro from '../components/InitialConfig/StepIntro'
import InstallerImg from '../img/dark-theme/installer.png'
import WorkflowIlustration from "../components/InitialConfig/WorkflowIlustration";

var initialConfigCommonJS = require("../js/initialConfigCommon.js");

function recuperarNombre(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        
  userData = JSON.parse(userData);

  var nombre = ""
  
  for (var i = 0; i < userData.UserAttributes.length; i++) {
      if(userData.UserAttributes[i].Name === "name"){
        nombre = userData.UserAttributes[i].Value            
      }
  }

  return nombre
}

// Initial config - Welcome
const UserTypeSelection = () => {
  
  useEffect(() => {    
    mostrarImagen("Usuario")
    document.getElementById("individual").checked = true
    console.log("Pantalla de selección de tipo de usuario cargada correctamente.")

    document.title = "HELIAS - Configuración inicial: Selección del tipo de usuario"

  });
  
  const navigate = useNavigate();

  function navegar(tipoUsuario){    
    if(initialConfigCommonJS.existeSesion()){
      // Y continuo a la siguiente página    
      if ( tipoUsuario === "Usuario" ){  
        navigate("/UserInitialConfig/Welcome")         
      }
      else{ 
        navigate("/InstallerInitialConfig/Welcome")         
      }    
    }
  }

  function seleccionarUsuario(){

    if(document.getElementById("individual").checked){
      navegar("Usuario")
    }
    else if(document.getElementById("installer").checked){
      navegar("Instalador")
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Debes seleccionar una opción.","negative")
    }

  }

  function mostrarImagen(tipoImagen){

    if(tipoImagen === "Usuario"){
      document.getElementById("workflowIllustration").className = document.getElementById("workflowIllustration").className.replaceAll(" hidden", "")
      document.getElementById("imagenInstalador").className += " hidden"    
    }
    else{
      document.getElementById("workflowIllustration").className += " hidden" 
      document.getElementById("imagenInstalador").className = document.getElementById("workflowIllustration").className.replaceAll(" hidden", "")   
    }

  }

  return (      
    <main>

      <InitialConfigHeader step={"NEW"}/>

      <section id="welcome-01" className="step wrapper">
        <div className="content-wrapper half">          
          
          <StepIntro 
            Title={"Hola "+recuperarNombre()}
            Intro={              
              <p>Antes de nada necesito saber qué tipo de usuario eres:</p>               
            }            
          />

          <fieldset>
            <fieldset className="radio multiple">
              <input type="radio" id="individual" name="radio"/>
              <label className="selector icon-wrapper" htmlFor="individual" onClick={() => mostrarImagen("Usuario")}>
                <figure className="avatar size-l"><span className="material-icon">person</span></figure>
                <div className="content">
                  <h1 className="size-l">Usuario</h1>
                  <p>Si eres un usuario normal que quiere que Helias se preocupe de su casa, comunidad de vecinos, oficina, etc... esta es tu opción.</p>
                </div>
              </label>

              <input type="radio" id="installer" name="radio"/>
              <label className="selector icon-wrapper" htmlFor="installer" onClick={() => mostrarImagen("Instalador")}>
                <figure className="avatar size-l"><span className="material-icon">engineering</span></figure>
                <div className="content">
                  <h1 className="size-l">Instalador</h1>
                  <p>Si eres un instalador de una empresa que quiere tener monitorizadas las instalaciones que ha realizado y configurar alertas para la mismas... esta es tu opción</p>
                </div>
              </label>
            </fieldset>

            <button id="botonContinuarSeleccionUsuario" className="button primary" onClick={() => seleccionarUsuario()}>Continuar</button>

          </fieldset>

        </div>        

        <WorkflowIlustration illustrationElements={"HOUSE, GRID_CONNECTED"}/>

        <picture id="imagenInstalador" className="main-illustration installer">
          <picture className="layer">
            <img src={InstallerImg} alt="installer"/>
          </picture>
        </picture>



      </section>

    </main>
  )
}

export default UserTypeSelection